import { SLOT_PREVIEW_STATE } from '../constants';
const SLOT_STATE_REGEXP = new RegExp(/-(?=[^-]*$)/);
function isSlotPreviewState(value) {
    return Object.values(SLOT_PREVIEW_STATE).includes(value);
}
export const extractSlotPreviewState = (slot) => {
    if (!slot) {
        return {};
    }
    const [slotId, slotPreviewState] = slot.split(SLOT_STATE_REGEXP);
    return isSlotPreviewState(slotPreviewState)
        ? { [slotId]: slotPreviewState }
        : {};
};
export const isSlotHighlighted = (slotPreviewState, slotId) => {
    return slotPreviewState[slotId] === SLOT_PREVIEW_STATE.HIGHLIGHTED;
};
//# sourceMappingURL=extractSlotPreviewState.js.map